const measurementContainerId = '__text_measure_container'

function ensureContainer(): HTMLElement {
  let container = document.getElementById(measurementContainerId)

  if (container) {
    return container
  }

  container = document.createElement('div')
  container.id = measurementContainerId

  // keep it off-screen and not affecting layout, but still renderable
  container.style.position = 'absolute'
  container.style.left = '-99999px'
  container.style.top = '-99999px'
  container.style.visibility = 'hidden'
  container.style.whiteSpace = 'pre' // preserve spaces exactly
  container.style.pointerEvents = 'none'
  container.style.zIndex = '-1'

  document.body.appendChild(container)

  return container
}

export function measureText(
  text: string,
  style: React.CSSProperties = {},
): number {
  const container = ensureContainer()

  const span = document.createElement('span')
  span.textContent = text
  Object.assign(span.style, style)

  container.appendChild(span)
  const rect = span.getBoundingClientRect()
  container.removeChild(span)

  return rect.width
}
